import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import { getDashLang } from '../../utils/dashboardTranslations';

export default function SubscriptionCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const lang = getDashLang();

  useEffect(() => {
    const result = searchParams.get('Result');
    const cancelled = searchParams.get('cancelled');

    // If cancelled
    if (result === 'CANCELED' || cancelled === '1') {
      navigate('/dashboard/subscription?payment=failed', { replace: true });
      return;
    }

    // Collect all query params to send to backend
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    api.post('/subscription/verify-tahseeel', params)
      .then((res) => {
        if (res.data.status === 'success') {
          navigate('/dashboard/subscription?payment=success', { replace: true });
        } else {
          navigate('/dashboard/subscription?payment=failed', { replace: true });
        }
      })
      .catch((err) => {
        console.error('verify-tahseeel error:', err?.response?.data || err.message);
        navigate('/dashboard/subscription?payment=failed', { replace: true });
      });
  }, []);

  return (
    <div className="empty-state">
      <p style={{ fontSize: 16 }}>{lang === 'ar' ? 'جاري معالجة الدفع...' : 'Processing payment...'}</p>
    </div>
  );
}
